import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";
// 空运增删改查
export const operAir = (params) => {
  return axios.request({
    url: `/common/air${params.id ? "/" + params.id : ""}`,
    [params.method == "get" ? "params" : "data"]: params,
    method: params.method,
  });
};

// 获取清关文件
export const getLoadType = (params) => {
  return axios.request({
    url: `/common/transport/loadType`,
    params,
    method: "get",
  });
};

// 清关代理（空海运）
export const getTransportAgent = (params) => {
  return axios.request({
    url: `/common/transport/agent`,
    params,
    method: "get",
  });
};

// 出货模式（空海运）
export const getShippingMode = (params) => {
  return axios.request({
    url: `/common/transport/shippingMode`,
    params,
    method: "get",
  });
};

// 获取中港单号
export const getZhongGang = (params) => {
  return axios.request({
    url: `/common/transport/packing`,
    params,
    method: "get",
  });
};

// 创建空运提单
export const operAirOrder = (params) => {
  return axios.request({
    url: `/extract/extract_air${params.id ? "/" + params.id : ""}`,
    [params.method == "get" ? "params" : "data"]: params,
    method: params.method ? params.method : "get",
  });
};

// 获取中港列表
export const getZhongGangList = (id) => {
  return axios.request({
    url: `/extract/extract_air/getPacking/${id}`,
    method: "get",
  });
};

// 获取中港单数量
export const getZhongGangCount = (id) => {
  return axios.request({
    url: `/extract/extract_air/getOrders/${id}`,
    method: "get",
  });
};

// 获取空运航线
export const getAirLine = (params) => {
  return axios.request({
    url: `/common/transport/airLine`,
    params,
    method: "get",
  });
};

// 获取客户
export const getCustomer = (params) => {
  return axios.request({
    url: `/extract/extract_air/client`,
    params,
    method: "get",
  });
};

// 根据客户获取中港单
export const getZhongGangByClient = (params) => {
  return axios.request({
    url: `/extract/extract_air/packing/${params.id}`,
    method: "get",
    params,
  });
};

// 新增中港代理
export const addZhongGang = (data) => {
  return axios.request({
    url: `/warehouse/airpacking/setHkAgent/${data.id}`,
    method: "post",
    data,
  });
};

// 成本导入
export const importCost = (data) => {
  return axios.request({
    url: `/extract/agent/cost/upload`,
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken(),
    },
  });
};
// 收入导入
export const importIncome = (data) => {
  return axios.request({
    url: `/extract/agent/income/upload`,
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken(),
    },
  });
};

// 空运唛头标签列表
export const getAirLabel = (params) => {
  return axios.request({
    url: `/extract/mark/index`,
    params,
    method: "get",
  });
};

// 空运唛头上传
export const uploadAirLabel = (data) => {
  return axios.request({
    url: `/extract/mark/upload`,
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken(),
    },
  });
};

// 删除唛头标签
export const delAirLabel = (data) => {
  return axios.request({
    url: `/extract/mark/delete`,
    method: "post",
    data,
  });
};

export const createBill = (params) => {
  return axios.request({
    url: `/extract/extract_air/createBill`,
    params,
    method: "get",
  });
};

export const businessType = (params) => {
  return axios.request({
    url: `/common/transport/businessType`,
    params,
    method: "get",
  });
};

export const getCustomerInfo = (params) => {
  return axios.request({
    url: `/extract/extract_air/getCustomer`,
    params,
    method: "get",
  });
};
export const airPortName = (params) => {
  return axios.request({
    url: `/common/transport/airPortName`,
    params,
    method: "get",
  });
};
export const getPackingInfo = (params) => {
  return axios.request({
    url: `/extract/extract_air/getPackingInfo`,
    params,
    method: "get",
  });
};



export const newOperAirOrder = (params) => {
  return axios.request({
    url: `/extract/extract_air/create`,
    [params.method == "get" ? "params" : "data"]: params,
    method: params.method ? params.method : "get",
  });
};
